import type { DateTime } from 'luxon'

export type TimelineAddress = {
  street?: string | null
  city?: string | null
  state?: string | null
  zip?: string | null
}

/** Structural waypoint subset, independent of generated query types. */
export type TimelineWaypoint = {
  id: number
  name?: string | null
  status?: string | null
  address?: TimelineAddress | null
  order?: {
    id: number
    customer?: { name?: string | null; nickname?: string | null } | null
    site?: { name?: string | null; address?: TimelineAddress | null } | null
  } | null
  actualArrivalTimeLocal?: string | null
  conflictArrivalTimeLocal?: string | null
  scheduledArrivalTimeLocal?: string | null
  actualDepartureTimeLocal?: string | null
  conflictDepartureTimeLocal?: string | null
  scheduledDepartureTimeLocal?: string | null
}

export type WaypointPosition = {
  isFirst: boolean
  isLast: boolean
  isCompleted: boolean
}

/** Reference date of the assignment, for weekday suffixes on times. */
export type TimelineDate = DateTime | undefined

export const formatWaypointAddress = (address: TimelineAddress): string =>
  [address.city, address.state].filter(Boolean).join(', ')
